import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Group,
  Center,
  Select,
  Button,
  Pagination,
  Checkbox,
  Modal,
  TextInput,
  Tabs, 
  Divider,
  Paper,
  Grid,
  Stack,
  NumberInput,
  Box,
  Skeleton,
} from "@mantine/core";
import {
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconTrash,
  IconEdit,
  IconUserPlus,
  IconEye,
  IconPhoto,
  IconGiftCard,
  IconSettings,
  IconPhotoCancel
} from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import classes from "./Voucher.module.css";
import { RowDataBdayVoucher } from "./types";
import { props } from "./props";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { CustomTable } from "../Table/CustomTable";
import { bdayVoucher } from "../types/RowDataTypes";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";
import CreateVoucher from "./CreateVoucher";
import DeleteVoucher from "./DeleteVoucher";
// import getVoucherTable from "../../DataDisplay/DataDisplayTable/VoucherTable";
import getVoucherBdayTable from "../../DataDisplay/DataDisplayTable/VoucherBdayTable";
import { useQuery, useMutation, useQueryClient  } from 'react-query';
import { useForm } from '@mantine/form';

import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_mm } from "../../helper/DateTime";

enum ColumnHeaderToFilterPair {
  VOUCHER = "Voucher ID",
//   UID = "UID",
  FULLNAME = "Fullname",
  PHONE_NUMBER = "Phone Number",
  DOB =  "DOB",
//   XID = "XID",
//   TITLE = "Title",
//   TYPE = "Type",
//   AMOUNT = "Amount",
//   REMARKS = "Remarks",
  START_DATE = "Start Date",
  END_DATE = "End Date",
//   XCODE = "XCode",
//   XREDEMPTION_ID = "XRedemptionID",
//   XREDEMPTION_TYPE = "XRedemptionType",
//   COST = "Cost",
//   IMAGESEARCH = "Image Search",
//   STATUS = "Status",
    // QUANTITY = "Quantity",
}

const colFilter = ColumnHeaderToFilterPair;
const colFilters: { [key in ColumnHeaderToFilterPair]: string } = {
  [colFilter.VOUCHER]: "voucher_id",
//   [colFilter.UID]: "uid",
  [colFilter.FULLNAME]: "fullname",
  [colFilter.PHONE_NUMBER]: "phone_number",
  [colFilter.DOB]: "dob",
//   [colFilter.XID]: "xid",
//   [colFilter.TITLE]: "title",
//   [colFilter.TYPE]: "type",
//   [colFilter.AMOUNT]: "amount",
//   [colFilter.REMARKS]: "remarks",
  [colFilter.START_DATE]: "startDate",
  [colFilter.END_DATE]: "endDate",
//   [colFilter.XCODE]: "xcode",
//   [colFilter.XREDEMPTION_ID]: "xredemptionId",
//   [colFilter.XREDEMPTION_TYPE]: "xredemptionType",
//   [colFilter.COST]: "cost",
//   [colFilter.IMAGESEARCH]: "imgSrc",
//   [colFilter.STATUS]: "status",
    // [colFilter.QUANTITY]: "cost",
};

function Th({ children, sortable, reversed, sorted, onSort }: props) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  const allowedSorts = [
    // colFilter.TITLE.toLowerCase(),
    // colFilter.TYPE.toLowerCase(),
    // colFilter.AMOUNT.toLowerCase(),
    colFilter.START_DATE.toLowerCase(),
    colFilter.END_DATE.toLowerCase(),
    // colFilter.STATUS.toLowerCase(),
    // colFilter.XCODE.toLowerCase(),
    // colFilter.COST.toLowerCase(),
  ];

  return (
    <Table.Th className={`${classes.th} ${sortable ? classes.sortable : ""}`}>
      {allowedSorts.includes(children!!.toString().toLowerCase()) ? (
        <UnstyledButton onClick={onSort} className={classes.control}>
          <div className={classes.sortableHeader}>
            <Text fw={500} fz="sm">
              {children}
            </Text>
            <Center className={classes.icon}>
              <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </Center>
          </div>
        </UnstyledButton>
      ) : (
        <Text fw={500} fz="sm">
          {children}
        </Text>
      )}
    </Table.Th>
  );
}

const initialData: RowDataBdayVoucher[] = [
  {
    voucher_id: "",
    uid: "",
    xid: "",
    title: "",
    type: "",
    amount: "",
    remarks: "",
    startDate: "",
    endDate: "",
    xCode: "",
    xRedemptionID: "",
    xRedemptionType: "",
    cost: "",
    imageSrc: "",
    status: "",
    action: "",
    numVouchers: "",
    terms_id: "",
    numberOfVoucher: 0,
    numberOfClaimedVoucher: 0,
    fullname: "",
    dob: "",
    phone_number: "",
  },
];

export function VoucherBirthday() {
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient()
  const [search, setSearch] = useState<string>("");
  const [sortedData, setSortedData] = useState(initialData);
  const [sortBy, setSortBy] = useState<keyof RowDataBdayVoucher | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [tableStateChanged, setTableStateChanged] = useState(0);
  const changeTableState = () => {
    setTableStateChanged(Math.random() * Math.random());
  };

  const form = useForm({
    initialValues: {
        title: "",
        type: 0,
        amount: 1,
        remarks: "",
        xCode: "",
        xRedemptionID: "",
        xRedemptionType: "",
        imageSrc: "",
        terms_id: "",
    },

    validate: {
        title: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
        amount: (value) => (value > 0 ? null : 'Invalid amount'),
        remarks: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
        // xCode: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
        // xRedemptionID: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
        // xRedemptionType: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
        terms_id: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
    },
  });

    const getTermsQuery = useQuery(
        "getTerms",
        async ({ signal }) => (await axiosPrivate.get("/api/admin/terms-conditions/read-for-select", { signal })).data.terms,
        {
            initialData: [],
            onSuccess: (res) => {
                // console.log(res)
            },
            onError: () => {

            }
        }
    );

    const getBdayVoucherQuery = useQuery(
        "getBdayVoucher",
        async ({ signal }) => (await axiosPrivate.get("/api/admin/bday-voucher/read", { signal })).data.bdayVoucher,
        {
            initialData: null,
            onSuccess: (res) => {
                // console.log(res)
                form.setValues({
                    title: res.title,
                    amount: res.amount,
                    remarks: res.remarks,
                    xCode: res.xcode,
                    xRedemptionID: res.xredemptionId,
                    imageSrc: res.imgSrc,
                    terms_id: res.terms_id,
                })
            },
            onError: () => {

            }
        }
    );

    const updateBdayVoucherMutation = useMutation(
        (data: any) => axiosPrivate.post("/api/admin/bday-voucher/update", data, {headers: {'Content-Type': 'multipart/form-data'}}),
        {
            onSuccess: (res: any) => {
                queryClient.invalidateQueries({ queryKey: ['getBdayVoucher'] })
                setImgFile(null)
                showSuccessAlert("Birthday Voucher Successfully Updated");
            },
            onError:(err: any) => {
                // setAddRebateFormVisible(false);
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );

  const checkboxesFilter: JSX.Element[] = [];

  //Set allowed search filter checkbox to be shown
  const allowedFilters = [
    colFilters[colFilter.FULLNAME],
    colFilters[colFilter.PHONE_NUMBER],

    // colFilters[colFilter.REMARKS],
    // colFilters[colFilter.XCODE],
  ];
  for (const [key, value] of Object.entries(colFilters)) {
    if (allowedFilters.includes(value)) {
      const checkboxFilter: JSX.Element = (
        <Checkbox value={value} label={key} />
      );
      checkboxesFilter.push(checkboxFilter);
    }
  }

  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearch(input);
  };

  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const resetPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      return true;
    }
    return false;
  };

  const fetchedData = useFetchRowData(
    itemsPerPage,
    currentPage,
    search,
    selectedFilters,
    tableStateChanged,
    sortBy ?? "createdAt",
    reverseSortDirection ? "DESC" : "ASC",
    bdayVoucher,
    getVoucherBdayTable().create()
  );

  const itemsOnPage = useRef(0);
  const [totalRows, setTotalRows] = useState<number>(0);
  const rowData: RowDataBdayVoucher[] | null = fetchedData.data as RowDataBdayVoucher[];
  const isLoading: boolean = fetchedData.isLoading;
  const [RowDataVoucher, setRowDataVoucher] = useState<RowDataBdayVoucher[] | null>(
    null
  );

  useEffect(() => {
    setRowDataVoucher(rowData);
    itemsOnPage.current = fetchedData.itemsOnPage;
    setTotalRows(fetchedData.totalRows);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData]);

  // Separate state for the modal related to adding customers
  const [isAddVoucherFormVisible, setAddVoucherFormVisible] = useState(false);

  // Separate state for the modal related to viewing/editing customers
  const [selectedRow, setSelectedRow] = useState<RowDataBdayVoucher | null>(null);
  const [isViewMode, setViewMode] = useState(false);
  const [isEditMode, setEditMode] = useState(false);

  const [isDeleteConfirmationVisible, setDeleteConfirmationVisible] =
    useState(false);
  const [rowToDelete, setRowToDelete] = useState<RowDataBdayVoucher | null>(null);
  const [passwordsMatch, setPasswordsMatch] = useState(true);

    const [imgFile, setImgFile] = useState<any>(null);
    const [previewImg, setPreviewImg] = useState<string | null>(null)

  const handleView = (row: RowDataBdayVoucher) => {
    setSelectedRow(row);
    setViewMode(true);
  };

  const handleEdit = (row: RowDataBdayVoucher) => {
    setSelectedRow(row);
    setEditMode(true);
    // Set the initial values for editing based on the selected row
  };

  const handleDelete = (row: RowDataBdayVoucher) => {
    setRowToDelete(row);
    setDeleteConfirmationVisible(true);
  };

  const handleConfirmDelete = () => {
    if (rowToDelete) {
    //   console.log(rowToDelete);
      axiosPrivate
        .post("/api/admin/admin/delete", {
          voucher_id: rowToDelete.uid,
        })
        .then((response) => {
          setDeleteConfirmationVisible(false);
          if (
            itemsOnPage.current == 1 &&
            currentPage !== 1 &&
            currentPage == Math.ceil(totalRows / itemsPerPage)
          )
            setCurrentPage((prev) => prev - 1);
          else changeTableState();
        })
        .catch((err) => {});

      const updatedData = sortedData.filter((row) => row !== rowToDelete);
      setSortedData(updatedData);
      setDeleteConfirmationVisible(false);
    }
  };

  const handleCancelDelete = () => {
    setRowToDelete(null);
    setDeleteConfirmationVisible(false);
  };

  const setSorting = (field: keyof RowDataBdayVoucher) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    setSortBy(field);
    changeTableState();
  };

  const startIndex = (currentPage - 1) * itemsPerPage;

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
  };

  const handleAddVouchers = () => {
    setAddVoucherFormVisible(true);
  };

  const handleAddVoucher = (newVoucherData: RowDataBdayVoucher) => {
    axiosPrivate
      .post(
        "/api/admin/vouchers/generate-vouchers",
        {
          title: newVoucherData.title,
          numberOfVoucher: newVoucherData.numVouchers,
          code: newVoucherData.xCode,
          types: newVoucherData.type,
          amount: newVoucherData.amount,
          remarks: newVoucherData.remarks,
          startDate: newVoucherData.startDate,
          endDate: newVoucherData.endDate,
          cost: newVoucherData.cost,
          terms_id: newVoucherData.terms_id,
          image: newVoucherData.imageSrc,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {

        // const data = res.data.payload;
        // const returnedData: RowDataVoucher = {
        //   ...newVoucherData,
        //   uid: data.voucher_id,
        // };

        // if (itemsOnPage.current < itemsPerPage) {
        //   if (!reverseSortDirection)
        //     setRowDataVoucher((prevData) => [returnedData, ...prevData!!]);
        //   else setRowDataVoucher((prevData) => [...prevData!!, returnedData]);
        // }
        // itemsOnPage.current = itemsOnPage.current + 1;
        // setTotalRows((prevData) => prevData + 1);

        changeTableState();
        // console.log(`after ${itemsOnPage.current}`);
        showSuccessAlert("Voucher Successfully Created");
      })
      .catch((err) => {
        showErrorAlert("An error has occured");
      });

    setSortedData((prevData) => [...prevData, newVoucherData]);

    // Close the modal
    setAddVoucherFormVisible(false);
  };

  const handleUpdateChanges = (data: any) => {
    // console.log(data)
    updateBdayVoucherMutation.mutate({
        title: data?.title,
        amount: data?.amount,
        remarks: data?.remarks,
        terms_id: data?.terms_id,
        image: imgFile ? imgFile : null,
    })
  };

  const rowsToMap = RowDataVoucher ?? [];
  const rows = rowsToMap.map((row, index) => (
    <Table.Tr key={index}>
      <Table.Td>{startIndex + index + 1}</Table.Td>
      <Table.Td>{row.voucher_id}</Table.Td>
      {/* <Table.Td>{row.uid}</Table.Td> */}
      <Table.Td>{row.fullname}</Table.Td> 
      <Table.Td>{row.phone_number}</Table.Td> 
      <Table.Td>{formatYYYY_MM_DD(row.dob)}</Table.Td> 

      {/* <Table.Td>{row.title}</Table.Td> */}
      {/* <Table.Td>{row.type == "0" ? "Currency" : "Percentage"}</Table.Td> */}
      {/* <Table.Td>{row.amount}</Table.Td> */}
      {/* <Table.Td>{row.remarks}</Table.Td> */}
      <Table.Td>
        {" "}
        {new Date(row.startDate).toLocaleString("en-MY", {
          timeZone: "Asia/Kuala_Lumpur",
        })}
      </Table.Td>
      <Table.Td>
        {" "}
        {new Date(row.endDate).toLocaleString("en-MY", {
          timeZone: "Asia/Kuala_Lumpur",
        })}
      </Table.Td>
      {/* <Table.Td>{row.xCode}</Table.Td> */}
      {/* <Table.Td>{row.xRedemptionID}</Table.Td> */}
      {/* <Table.Td>{row.xRedemptionType}</Table.Td> */}
      {/* <Table.Td>{row.cost}</Table.Td> */}
      {/* <Table.Td>{row.imageSrc}</Table.Td> */}
      {/* <Table.Td>{row.status}</Table.Td> */}
      {/* <Table.Td>{row.numberOfClaimedVoucher}/{row.numberOfVoucher}</Table.Td> */}
      <Table.Td className={classes.actionButtons}>
        <button onClick={() => handleView(row)} className={classes.viewbutton}>
          <IconEye /> View
        </button>
      </Table.Td>
    </Table.Tr>
  ));

  const handleSelectPage = (selectedPage: number) => {
    if (selectedPage != currentPage) setCurrentPage(selectedPage);
  };

  const imageDropzoneRef = useRef<() => void>(null);

  const handleImageUpload = (files: File[]) => {
        const file = files[0];
        if (file) {
            setImgFile(file)
        };
    }

  useEffect(() => {
    if (!imgFile) {
        setPreviewImg(null)
        return
    }

    const objectUrl = URL.createObjectURL(imgFile)
    setPreviewImg(objectUrl)

    return () => URL.revokeObjectURL(objectUrl)
}, [imgFile])

  return (
    <div className={classes.VoucherContainer}>
      {/* <ScrollArea className={classes.parentContainer}> */}
        <Header title="Birthday Voucher" />
        <Tabs
          defaultValue="claimed-voucher"
          color="blueviolet"
          variant="pills"
        //   onChange={(value) => {
        //     handleTabChange(value);
        //   }}
        >
            <Tabs.List ml={20} mt={"md"}>
                <Tabs.Tab value="claimed-voucher" className={classes.tabTitle}>
                    Claimed Voucher
                </Tabs.Tab>
                <Tabs.Tab value="voucher-config" className={classes.tabTitle} leftSection={<IconSettings style={{ width: 14, height: 14}} />}>
                    Voucher Config
                </Tabs.Tab>
            </Tabs.List>
            <Divider mb="md" mx={20}/>
            <Tabs.Panel value="claimed-voucher">
                <div className={classes.searchBarContainer}>
                    <SearchBar
                        isLoading={isLoading}
                        resetPage={resetPage}
                        changeTableState={changeTableState}
                        search={search}
                        handleSearch={handleSearch}
                        setShowFilterOptions={setShowFilterOptions}
                        showFilterOptions={showFilterOptions}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                        checkboxesFilter={checkboxesFilter}
                    />

                    {/* <div className={classes.addButtonContainer}>
                        <Button
                        onClick={handleAddVouchers}
                        className={classes.addVoucherButton}
                        >
                        <IconGiftCard style={{ marginRight: "5px" }} /> Create Voucher
                        </Button>
                    </div> */}
                </div>
                <ScrollArea
                w={
                    window.innerWidth -
                    document.getElementById("nav-bar")!!.getBoundingClientRect().width
                }
                >
                    <CustomTable
                        colHeaders={Object.values(ColumnHeaderToFilterPair)}
                        filters={Object.values(colFilters)}
                        reverseSortDirection={reverseSortDirection}
                        sortBy={sortBy}
                        setSorting={setSorting}
                        customclasses={classes}
                        Th={Th}
                        rowData={rowData}
                        rows={rows}
                    />
                    <div className={classes.footerContainer}>
                        <div className={classes.resultCount}>
                            <Text>
                            {`Showing `}
                            <span style={{ fontWeight: "bold" }}>{startIndex + 1}</span>
                            {`-`}
                            <span style={{ fontWeight: "bold" }}>
                                {Math.min(currentPage * itemsPerPage, totalRows)}
                            </span>
                            {` of `}
                            <span style={{ fontWeight: "bold" }}>{totalRows}</span>
                            {` results`}
                            </Text>
                        </div>

                        <div className={classes.rightContainer}>
                            <div className={classes.rowsPerPageSelector}>
                            <Select
                                placeholder="Rows per page"
                                data={["10", "20", "50"]}
                                value={itemsPerPage.toString()}
                                onChange={(value) =>
                                handleRowsPerPageChange(parseInt(value as string, 10))
                                }
                            />
                            </div>

                            <div className={classes.paginationSelector}>
                            <Pagination
                                color="blueviolet"
                                value={currentPage}
                                total={Math.ceil(totalRows / itemsPerPage)}
                                onNextPage={() => handlePageChange(currentPage + 1)}
                                onPreviousPage={() => handlePageChange(currentPage - 1)}
                                onChange={(value: number) => handleSelectPage(value)}
                            />
                            </div>
                        </div>
                    </div>
                </ScrollArea>
            </Tabs.Panel>

            <Tabs.Panel value="voucher-config">
                <Box
                    w={
                        window.innerWidth -
                        document.getElementById("nav-bar")!!.getBoundingClientRect().width
                    }
                >
                    <Paper px={20}>
                        <Grid>
                            <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                                <Skeleton visible={getBdayVoucherQuery.isFetching}>
                                <form onSubmit={form.onSubmit((values) => handleUpdateChanges(values))}>
                                <Stack gap={'sm'}>
                                    <TextInput
                                        label="Voucher Title"
                                        placeholder="Input title"
                                        required
                                        {...form.getInputProps('title')}
                                    />
                                    <NumberInput
                                        label="Amount"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input an amount"
                                        // value={newVoucher.amount}
                                        // onChange={(e) => setNewVoucher({ ...newVoucher, amount: e })}
                                        min={1}
                                        max={999}
                                        required
                                        {...form.getInputProps('amount')}
                                    />
                                    <TextInput
                                        label="Remarks"
                                        placeholder="Input remarks"
                                        maxLength={255}
                                        required
                                        // value={newVoucher.remarks}
                                        // onChange={(e) =>
                                        //     setNewVoucher({ ...newVoucher, remarks: e.currentTarget.value })
                                        // }
                                        {...form.getInputProps('remarks')}

                                    />
                                    {/* <TextInput
                                        label="X Code"
                                        placeholder="Input X Code"
                                        maxLength={255}
                                        required
                                        // value={newVoucher.xCode}
                                        // onChange={(e) =>
                                        //     setNewVoucher({ ...newVoucher, xCode: e.currentTarget.value })
                                        // }
                                        {...form.getInputProps('xCode')}
                                    /> */}
                                    <div>
                                    <Text fw={500} fz={15}>Image <span className={classes.format}>(.jpg, .png)</span> <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <Text fw={500} fz={12} c={'#5d5d5d'}>1000px x 500px</Text>
                                    <Dropzone
                                    onDrop={handleImageUpload}
                                    accept={["image/*"]}
                                    openRef={imageDropzoneRef}
                                    >
                                    <div className={classes.thumbnailContainer}>
                                        {previewImg || form.values.imageSrc ? (
                                        <img
                                            src={!previewImg ? form.values.imageSrc : previewImg}
                                            alt="Image"
                                            className={classes.thumbnailSize}
                                        />
                                        ) : (
                                        <p>
                                            <IconPhoto />
                                        </p>
                                        )}
                                    </div>
                                    </Dropzone>
                                    </div>
                                    <Group>
                                    {!previewImg ?
                                        <Button onClick={() => imageDropzoneRef.current?.()} leftSection={<IconPhoto />} fullWidth>Upload Image</Button>
                                    : 
                                        <Button onClick={() => setImgFile(null)} leftSection={<IconPhotoCancel />} fullWidth color="gray">Remove Image</Button>
                                    }
                                    </Group>
                                    <Select
                                        label="Select Terms & Conditions"
                                        placeholder="Pick terms & conditions"
                                        data={getTermsQuery.data}
                                        // value={newVoucher.terms_id}
                                        // onChange={(_value, option) => setNewVoucher({ ...newVoucher, terms_id: option.value })}
                                        {...form.getInputProps('terms_id')}
                                        required
                                    />
                                    <Group justify="flex-end" mt="md">
                                        <Button type="submit">Update Voucher</Button>
                                    </Group>
                                </Stack>
                                </form>
                                </Skeleton>
                            </Grid.Col>
                        </Grid>
                    </Paper>
                </Box>
            </Tabs.Panel>


        </Tabs>
        
        <ScrollArea>
          {/* Modal Form for Create, Edit, Delete */}
          <CreateVoucher
            isVisible={isAddVoucherFormVisible}
            onClose={() => setAddVoucherFormVisible(false)}
            onAddVoucher={(newVoucherData) => handleAddVoucher(newVoucherData)}
            terms={getTermsQuery.data}
          />
        </ScrollArea>

        <ScrollArea>
          {isViewMode && (
            <Modal
              opened={true}
              title={
                <div style={{ textAlign: "center", fontWeight: "bold" }}>
                  View
                </div>
              }
              onClose={() => setViewMode(false)}
              size="md"
              padding="lg"
            >
              <div className={classes.addCustomerForm}>
                {/* Display fields for viewing, but disable editing */}
                <TextInput
                  label="Voucher ID"
                  mb="sm"
                  value={selectedRow?.voucher_id}
                  readOnly
                />
                 <TextInput
                  label="UID"
                  mb="sm"
                  value={selectedRow?.uid}
                  readOnly
                />

                <TextInput
                  label="Fullname"
                  mb="sm"
                  value={selectedRow?.fullname}
                  readOnly
                />

                <TextInput
                  label="DOB"
                  mb="sm"
                  value={selectedRow?.dob}
                  readOnly
                />

                <TextInput
                  label="Phone Number"
                  mb="sm"
                  value={selectedRow?.phone_number}
                  readOnly
                />

                <TextInput
                  label="Amount"
                  mb="sm"
                  value={selectedRow?.amount}
                  readOnly
                />
                <TextInput
                  label="Remarks"
                  mb="sm"
                  value={selectedRow?.remarks}
                  readOnly
                />

                <TextInput
                  label="Start Date"
                  mb="sm"
                  value={formatYYYY_MM_DD_HH_mm(selectedRow?.startDate)}
                  readOnly
                />

                <TextInput
                  label="End Date"
                  mb="sm"
                  value={formatYYYY_MM_DD_HH_mm(selectedRow?.endDate)}
                  readOnly
                />
              </div>
            </Modal>
          )}
        </ScrollArea>
        {isDeleteConfirmationVisible && (
          <DeleteVoucher
            isOpen={isDeleteConfirmationVisible}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
          />
        )}
      {/* </ScrollArea> */}
    </div>
  );
}

export default VoucherBirthday;
